// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout-containerWith-l_O1J {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.Layout-container-_8w3N {
    max-width: 100%;
}

/* Text - Start */

.Layout-subText-qDUUU {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.Layout-navigationLink-WhHN_ a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.Layout-navigationLink-WhHN_ a:hover,
.Layout-navigationLink-WhHN_ a:focus,
.Layout-navigationLink-WhHN_ a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.Layout-noPadding-XTWiW {
    padding: 0;
}

.Layout-heading-_wyxa {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.Layout-widthInner-E8l13 {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.Layout-noMargin-u4yul {
    margin: 0;
}

.Layout-formControlInputTable-oEb75 {
    border: none;
    width: 100px;
    height: auto;
}

.Layout-backBtn-xmpMM {
    margin-left: 15px;
    display: inline-block;
}

.Layout-backBtn-xmpMM:active,
.Layout-backBtn-xmpMM:hover,
.Layout-backBtn-xmpMM:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.Layout-textAlignRight-iOeW1 {
    text-align: right;
}

.Layout-displayInlineBlock-oTahA {
    display: inline-block;
}

.Layout-displayBlock-NQHqa {
    display: block;
}

.Layout-countryCode-BgSSw {
    width: 15%;
    vertical-align: top;
}

.Layout-vtrMiddle-TVCIy {
    vertical-align: middle;
}

/* commonCss */

.Layout-editIcon-VDHMW {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.Layout-iconBtn-fgcxv,
.Layout-iconBtn-fgcxv:hover,
.Layout-iconBtn-fgcxv:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.Layout-profileImg-v2xLp {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.Layout-profileImgSection-fGUi1 {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.Layout-profileImgWidth-lVe2A {
    margin: 0;
    max-width: 100% !important;
}

.Layout-searchInput-hTXZ1 {
    width: 100%;
    max-width: 320px;
}

.Layout-backgroundImg-J6xvi {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.Layout-exportDisplay-zjYLS {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.Layout-exportTextSection-uHUfP {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.Layout-exportText-AmfFo {
    display: inline-block;
    padding-right: 5px;
}

.Layout-exportTextContainer-L17FD {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.Layout-vtrTextBottom-PjCxx {
    vertical-align: text-bottom;
}

.Layout-exportImg-FPr9e {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.Layout-noLink-pv63c,
.Layout-noLink-pv63c:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.Layout-singleCard-tyVQy {
    width: 500px;
    margin: 0 auto;
}

.Layout-defaultIcon-m6Iwt {
    background-size: 50px;
}

.Layout-assignProviderSearchInput-TE5Bq {
    width: 100%;
    max-width: 324px;
}

.Layout-searchGroupContainer-M9jSz {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .Layout-searchGroupContainer-M9jSz {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .Layout-widthInner-E8l13 {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .Layout-aboutGrid-BGHh0 img {
    position: relative;
    top: -25px !important;
  }

  .Layout-responsiveView-BcXE3 {
    width: 100% !important;
    max-width: 175px !important;
  }

  .Layout-positionFive-waq7S {
    top: 28% !important;
  }

  .Layout-positionTwo-nadQT {
    top: 28% !important;
  }

  .Layout-responsiveContentOne-JHxBo {
    top: -50px !important;
  }

  .Layout-positionFour-csVak {
    top: -50px !important;
  }

  .Layout-totalCss-Md1_V {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .Layout-navbar-expand-lg-_EzNs .Layout-navbar-toggler-KgHCG {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .Layout-profileImgSection-fGUi1 {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .Layout-navigationLink-WhHN_ a {
    color: var(--primary-foreground) !important;
  }

  .Layout-widthInner-E8l13 {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .Layout-responsiveContentOne-JHxBo {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .Layout-positionTwo-nadQT {
    top: 24% !important;
    left: -5% !important;
  }

  .Layout-positionThree-eexMU {
    top: 70% !important;
    left: -5% !important;
  }

  .Layout-positionFour-csVak {
    top: -42px !important;
    right: -5% !important;
  }

  .Layout-positionFive-waq7S {
    top: 20% !important;
    right: -5% !important;
  }

  .Layout-positionSix-Om4Cg {
    top: 70% !important;
    right: -5% !important;
  }

  .Layout-responsiveView-BcXE3 {
    width: 100% !important;
    max-width: 115px !important;
  }

  .Layout-aboutGrid-BGHh0 img {
    top: -1px !important;
  }

  .Layout-contentOne-VbBNO h1 {
    font-size: 16px !important;
  }

  .Layout-contentOne-VbBNO p {
    font-size: 12px !important;
  }


  .Layout-totalCss-Md1_V {
    width: 100% !important;
  }

  .Layout-padding-b6Vpf {
    padding: 0px 0 0 60px !important;
  }

  .Layout-singleCard-tyVQy {
    width: 100% !important;
  }

  .Layout-navigationLink-WhHN_ a:hover,
  .Layout-navigationLink-WhHN_ a:focus,
  .Layout-navigationLink-WhHN_ a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .Layout-navbar-collapse-q6XDG.Layout-show-vDYyI {
    right: 0% !important;
    top: 0 !important;
  }

  .Layout-navbar-collapse-q6XDG {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .Layout-content-Hbndx {
    float: none;
  }

  .Layout-mr-auto-KfSgJ.Layout-navbar-nav-PcbN0 {
    padding-bottom: 80px !important;
  }

  .Layout-navigationLink-WhHN_ a {
    color: var(--primary-foreground) !important;
  }

  .Layout-footer-ix1QT {
    padding: 35px 0 0 15px;
  }

  .Layout-widthInner-E8l13 {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .Layout-responsiveNoPadding-YLR6M {
    padding: 0px !important;
  }

  .Layout-contentOne-VbBNO {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .Layout-aboutContainer-aFznD {
    padding: 30px 0 30px !important;
  }

  .Layout-noPosition-HscbX {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .Layout-mobimleImg-twfSe {
    display: none !important;
  }

  .Layout-totalCss-Md1_V {
    width: 100% !important;
  }

  .Layout-imgWidth-RId6s {
    padding: 18px !important;
  }

  .Layout-searchInput-hTXZ1,
  .Layout-assignProviderSearchInput-TE5Bq {
    max-width: 100% !important;
  }

  .Layout-exportText-AmfFo {
    display: inline-block;
  }

  .Layout-gridSystem-Hb_2P {
    grid-template-columns: auto !important;
  }

  .Layout-padding-b6Vpf {
    padding: 52px 0 0 0 !important;
  }

  .Layout-heading-_wyxa {
    padding: 30px 0 24px !important;
  }

  .Layout-singleCard-tyVQy {
    width: 100% !important;
  }

  .Layout-displayGrid-fF696 {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .Layout-boxInner-PM8gy {
    padding: 35px 0 !important;
  }

  .Layout-navigationLink-WhHN_ a:hover,
  .Layout-navigationLink-WhHN_ a:focus,
  .Layout-navigationLink-WhHN_ a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .Layout-whiteDropdown-SoBQp select {
    width: 120px !important;
  }
}

/*
 * normalize.css is imported in JS file.
 * If you import external CSS file from your internal CSS
 * then it will be inlined and processed with CSS modules.
 */

/*
 * Base styles
 * ========================================================================== */

html {
  color: #222;
  font-family: var(--font-family-base);
}

a,
a:hover,
a:focus,
a:active {
  color: var(--primary-link-foreground);
  text-decoration: unset;
}

/*
 * Remove text-shadow in selection highlight:
 * https://twitter.com/miketaylr/status/12228805301
 *
 * These selection rule sets have to be separate.
 * Customize the background color to match your design.
 */

/*
 * A better looking default horizontal rule
 */

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}

/*
 * Remove the gap between audio, canvas, iframes,
 * images, videos and the bottom of their containers:
 * https://github.com/h5bp/html5-boilerplate/issues/440
 */

audio,
canvas,
iframe,
img,
svg,
video {
  vertical-align: middle;
}

/*
 * Remove default fieldset styles.
 */

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

/*
 * Allow only vertical resizing of textareas.
 */

textarea {
  resize: vertical;
}

/*
 * Browser upgrade prompt
 * ========================================================================== */

.browserupgrade {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}

/*
 * Print styles
 * Inlined to avoid the additional HTTP request:
 * http://www.phpied.com/delay-loading-your-print-css/
 * ========================================================================== */

@media print {

  *,
  *::before,
  *::after {
    background: transparent !important;
    color: #000 !important;
    /* Black prints faster: http://www.sanbeiji.com/archives/953 */
    -webkit-box-shadow: none !important;
            box-shadow: none !important;
    text-shadow: none !important;
  }

  a,
  a:visited {
    text-decoration: underline;
  }

  a[href]::after {
    content: ' (' attr(href) ')';
  }

  abbr[title]::after {
    content: ' (' attr(title) ')';
  }

  /*
   * Don't show links that are fragment identifiers,
   * or use the \`javascript:\` pseudo protocol
   */

  a[href^='#']::after,
  a[href^='javascript:']::after {
    content: '';
  }

  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }

  /*
   * Printing Tables:
   * http://css-discuss.incutio.com/wiki/Printing_Tables
   */

  thead {
    display: table-header-group;
  }

  tr,
  img {
    page-break-inside: avoid;
  }

  img {
    max-width: 100% !important;
  }

  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }

  h2,
  h3 {
    page-break-after: avoid;
  }
}

.Layout-paddingNone-wupAa {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css","webpack://./src/components/Layout/Layout.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;ACxPA;;;;EAIE;;AAEF;;+EAE+E;;AAE/E;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;;;;EAIE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;;;;;;EAME;;AAGF;;EAEE;;AAEF;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,UAAU;AACZ;;AAEA;;;;EAIE;;AAEF;;;;;;EAME,sBAAsB;AACxB;;AAEA;;EAEE;;AAEF;EACE,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE;;AAEF;EACE,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;+EAI+E;;AAE/E;;EAEE;;;IAGE,kCAAkC;IAClC,sBAAsB;IACtB,8DAA8D;IAC9D,mCAA2B;YAA3B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE;;EAEF;;IAEE,WAAW;EACb;;EAEA;;IAEE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;;;IAGE;;EAEF;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,UAAU;IACV,SAAS;EACX;;EAEA;;IAEE,uBAAuB;EACzB;AACF;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../Common.css';\n@import '../responsive-common.css';\n\n\n/*\n * normalize.css is imported in JS file.\n * If you import external CSS file from your internal CSS\n * then it will be inlined and processed with CSS modules.\n */\n\n/*\n * Base styles\n * ========================================================================== */\n\nhtml {\n  color: #222;\n  font-family: var(--font-family-base);\n}\n\na,\na:hover,\na:focus,\na:active {\n  color: var(--primary-link-foreground);\n  text-decoration: unset;\n}\n\n/*\n * Remove text-shadow in selection highlight:\n * https://twitter.com/miketaylr/status/12228805301\n *\n * These selection rule sets have to be separate.\n * Customize the background color to match your design.\n */\n\n\n/*\n * A better looking default horizontal rule\n */\n\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #ccc;\n  margin: 1em 0;\n  padding: 0;\n}\n\n/*\n * Remove the gap between audio, canvas, iframes,\n * images, videos and the bottom of their containers:\n * https://github.com/h5bp/html5-boilerplate/issues/440\n */\n\naudio,\ncanvas,\niframe,\nimg,\nsvg,\nvideo {\n  vertical-align: middle;\n}\n\n/*\n * Remove default fieldset styles.\n */\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\n/*\n * Allow only vertical resizing of textareas.\n */\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n * Browser upgrade prompt\n * ========================================================================== */\n\n:global(.browserupgrade) {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}\n\n/*\n * Print styles\n * Inlined to avoid the additional HTTP request:\n * http://www.phpied.com/delay-loading-your-print-css/\n * ========================================================================== */\n\n@media print {\n\n  *,\n  *::before,\n  *::after {\n    background: transparent !important;\n    color: #000 !important;\n    /* Black prints faster: http://www.sanbeiji.com/archives/953 */\n    box-shadow: none !important;\n    text-shadow: none !important;\n  }\n\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n\n  a[href]::after {\n    content: ' (' attr(href) ')';\n  }\n\n  abbr[title]::after {\n    content: ' (' attr(title) ')';\n  }\n\n  /*\n   * Don't show links that are fragment identifiers,\n   * or use the `javascript:` pseudo protocol\n   */\n\n  a[href^='#']::after,\n  a[href^='javascript:']::after {\n    content: '';\n  }\n\n  pre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n  }\n\n  /*\n   * Printing Tables:\n   * http://css-discuss.incutio.com/wiki/Printing_Tables\n   */\n\n  thead {\n    display: table-header-group;\n  }\n\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n\n  img {\n    max-width: 100% !important;\n  }\n\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n}\n\n.paddingNone {\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `Layout-containerWith-l_O1J`,
	"container": `Layout-container-_8w3N`,
	"subText": `Layout-subText-qDUUU`,
	"navigationLink": `Layout-navigationLink-WhHN_`,
	"noPadding": `Layout-noPadding-XTWiW`,
	"heading": `Layout-heading-_wyxa`,
	"widthInner": `Layout-widthInner-E8l13`,
	"noMargin": `Layout-noMargin-u4yul`,
	"formControlInputTable": `Layout-formControlInputTable-oEb75`,
	"backBtn": `Layout-backBtn-xmpMM`,
	"textAlignRight": `Layout-textAlignRight-iOeW1`,
	"displayInlineBlock": `Layout-displayInlineBlock-oTahA`,
	"displayBlock": `Layout-displayBlock-NQHqa`,
	"countryCode": `Layout-countryCode-BgSSw`,
	"vtrMiddle": `Layout-vtrMiddle-TVCIy`,
	"editIcon": `Layout-editIcon-VDHMW`,
	"iconBtn": `Layout-iconBtn-fgcxv`,
	"profileImg": `Layout-profileImg-v2xLp`,
	"profileImgSection": `Layout-profileImgSection-fGUi1`,
	"profileImgWidth": `Layout-profileImgWidth-lVe2A`,
	"searchInput": `Layout-searchInput-hTXZ1`,
	"backgroundImg": `Layout-backgroundImg-J6xvi`,
	"exportDisplay": `Layout-exportDisplay-zjYLS`,
	"exportTextSection": `Layout-exportTextSection-uHUfP`,
	"exportText": `Layout-exportText-AmfFo`,
	"exportTextContainer": `Layout-exportTextContainer-L17FD`,
	"vtrTextBottom": `Layout-vtrTextBottom-PjCxx`,
	"exportImg": `Layout-exportImg-FPr9e`,
	"noLink": `Layout-noLink-pv63c`,
	"singleCard": `Layout-singleCard-tyVQy`,
	"defaultIcon": `Layout-defaultIcon-m6Iwt`,
	"assignProviderSearchInput": `Layout-assignProviderSearchInput-TE5Bq`,
	"searchGroupContainer": `Layout-searchGroupContainer-M9jSz`,
	"aboutGrid": `Layout-aboutGrid-BGHh0`,
	"responsiveView": `Layout-responsiveView-BcXE3`,
	"positionFive": `Layout-positionFive-waq7S`,
	"positionTwo": `Layout-positionTwo-nadQT`,
	"responsiveContentOne": `Layout-responsiveContentOne-JHxBo`,
	"positionFour": `Layout-positionFour-csVak`,
	"totalCss": `Layout-totalCss-Md1_V`,
	"navbar-expand-lg": `Layout-navbar-expand-lg-_EzNs`,
	"navbar-toggler": `Layout-navbar-toggler-KgHCG`,
	"positionThree": `Layout-positionThree-eexMU`,
	"positionSix": `Layout-positionSix-Om4Cg`,
	"contentOne": `Layout-contentOne-VbBNO`,
	"padding": `Layout-padding-b6Vpf`,
	"navbar-collapse": `Layout-navbar-collapse-q6XDG`,
	"show": `Layout-show-vDYyI`,
	"content": `Layout-content-Hbndx`,
	"mr-auto": `Layout-mr-auto-KfSgJ`,
	"navbar-nav": `Layout-navbar-nav-PcbN0`,
	"footer": `Layout-footer-ix1QT`,
	"responsiveNoPadding": `Layout-responsiveNoPadding-YLR6M`,
	"aboutContainer": `Layout-aboutContainer-aFznD`,
	"noPosition": `Layout-noPosition-HscbX`,
	"mobimleImg": `Layout-mobimleImg-twfSe`,
	"imgWidth": `Layout-imgWidth-RId6s`,
	"gridSystem": `Layout-gridSystem-Hb_2P`,
	"displayGrid": `Layout-displayGrid-fF696`,
	"boxInner": `Layout-boxInner-PM8gy`,
	"whiteDropdown": `Layout-whiteDropdown-SoBQp`,
	"paddingNone": `Layout-paddingNone-wupAa`
};
module.exports = ___CSS_LOADER_EXPORT___;
